import React, { useEffect, useState } from "react";
import apiClient from "../../services/apiClient";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

export default function PaymentHistory() {
  
  const userId = useSelector((state) => state.userInfo?.user?.id);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchHistory = async () => {
    try {
      setLoading(true);

      const res = await apiClient.get(`/payment/history/${userId}`);

      if (!res) {
        toast.error("Failed to load history");
        return;
      }

      setHistory(res.data || []);
    } catch (err) {
      toast.error("Something went wrong");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) fetchHistory();
  }, [userId]);

  return (
    <>
    
    <div className="pageTitle1 px-5 py-4">
      <h3>Payment History</h3>
    </div>
    
    <div style={styles.wrapper}>
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead style={styles.thead}>
            <tr>
                <th  style={styles.th}>User Id</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Currency</th>
              <th style={styles.th}>Order ID</th>
              <th style={styles.th}>Payment ID</th>
              <th style={styles.th}>Date</th>
                            <th style={styles.th}>Status</th>

            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan="6" style={styles.noRecords}>Loading...</td>
              </tr>
            )}

            {!loading && history.length === 0 && (
              <tr>
                <td colSpan="6" style={styles.noRecords}>No records to display</td>
              </tr>
            )}

            {!loading &&
              history?.map((p) => (
                <tr key={p._id} style={styles.tr}>
                                      <td style={styles.td}>{p._id}</td>

                  <td style={styles.td}>{p.amount}</td>
                  <td style={styles.td}>{p.currency}</td>
                
                  <td style={styles.td}>{p.razorpay_order_id}</td>
                  <td style={styles.td}>{p.razorpay_payment_id}</td>
                  <td style={styles.td}>
                    {new Date(p.created_at).toLocaleString()}
                  </td>
                    <td style={styles.td}>
                    <span
                      style={{
                        ...styles.badge,
                        background:
                          p.status === "success"
                            ? "rgba(0, 185, 0, 0.12)"
                            : "rgba(255, 0, 0, 0.12)",
                        color: p.status === "success" ? "green" : "red",
                      }}
                    >
                      {p.status}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
    
    </>
  );
}

const styles = {
  wrapper: {
    padding: "20px",
    width: "100%",
  },

  title: {
    fontSize: "22px",
    marginBottom: "20px",
    fontWeight: 600,
  },

  tableContainer: {
    width: "100%",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #e5e5e5",
    background: "#fff",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  thead: {
    background: "#f7f7f7",
    color: "#333",
    borderBottom: "1px solid #ddd",
  },

  th: {
    padding: "12px",
    textAlign: "left",
    fontWeight: 600,
    fontSize: "14px",
    borderRight: "1px solid #eee",
  },

  tr: {
    borderBottom: "1px solid #eee",
  },

  td: {
    padding: "12px",
    fontSize: "14px",
    borderRight: "1px solid #eee",
  },

  badge: {
    padding: "4px 10px",
    borderRadius: "5px",
    fontSize: "12px",
    fontWeight: 600,
  },

  noRecords: {
    textAlign: "center",
    padding: "30px",
    color: "#999",
    fontStyle: "italic",
  },
};
